var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('activity-wrapper', [!_vm.shouldShowKeyboard ? _c('section', {
    staticClass: "questionSection"
  }, [_vm.currentRound.dynamicContent ? _c('dynamic-content', {
    attrs: {
      "dynamicContent": _vm.currentRound.dynamicContent
    }
  }) : _vm._e()], 1) : _vm._e(), !_vm.shouldShowKeyboard ? _c('section', {
    attrs: {
      "id": "dragAndDropSection"
    }
  }, [_c('div', {
    staticClass: "draggableArea"
  }, [_c('div', {
    staticClass: "draggableBankArea"
  }, _vm._l(_vm.currentRound.draggableItems, function (item) {
    return _c('div', {
      key: item.id,
      attrs: {
        "id": ("startingPoint-" + (item.id))
      }
    }, [_c('div', {
      staticClass: "draggableItem",
      attrs: {
        "id": ("draggable-" + (item.id))
      }
    }, [_c('div', {
      staticClass: "dragAndDropContent",
      style: {
        background: _vm.getDragContentBackground(item)
      }
    }, [_vm._v("\n              " + _vm._s(item.label) + "\n            ")])])]);
  }), 0)]), _c('div', {
    staticClass: "droppableArea"
  }, _vm._l(_vm.currentRound.dropZones, function (item) {
    var _vm$getAssociatedDrag;
    return _c('div', {
      key: item.id,
      staticClass: "dropItemContainer"
    }, [_c('html-renderer', {
      attrs: {
        "htmlObject": item.leftHtml
      }
    }), _c('div', {
      class: ("droppableItem " + (_vm.getDroppableItemClass())),
      style: {
        backgroundColor: ((_vm.getDroppableBackground(item)) + " !important")
      },
      attrs: {
        "id": ("dropArea-" + (item.id))
      }
    }, [_vm.isGuessedCorrectly(item) && !_vm.shouldShowKeyboard ? _c('CorrectIcon', {
      attrs: {
        "height": "36px",
        "width": "36px"
      }
    }) : _vm._e(), _vm.isGuessedIncorrectly(item) && !_vm.shouldShowKeyboard ? _c('WrongIcon', {
      attrs: {
        "height": "36px",
        "width": "36px"
      }
    }) : _vm._e(), _vm.showCorrectAnswers && !_vm.isGuessedCorrectly(item) && !_vm.isSubmitted ? _c('div', {
      staticClass: "dragAndDropContent correctAnswerContent"
    }, [_vm._v("\n            " + _vm._s((_vm$getAssociatedDrag = _vm.getAssociatedDraggableItem(item.correctItemIds)) === null || _vm$getAssociatedDrag === void 0 ? void 0 : _vm$getAssociatedDrag.label) + "\n          ")]) : _vm._e()], 1), _c('html-renderer', {
      attrs: {
        "htmlObject": item.rightHtml
      }
    })], 1);
  }), 0)]) : _vm._e(), _vm.shouldShowKeyboard ? _c('div', {
    attrs: {
      "id": "textContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "steps"
    }
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound.typeOverText && _vm.currentRound.typeOverText.directionsHtml
    }
  }), _c('text-display-list', {
    attrs: {
      "id": "input",
      "text-size": "medium-large"
    }
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.typeOverText && _vm.currentRound.typeOverText.text,
      "text-step": 0
    }
  })], 1)], 1)]) : _vm._e(), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }